import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { FullCalenderComponent } from '../../../full-calender/full-calender.component'
import { StorageService } from '../../../../../shared/services/storage.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { DatePipe } from '@angular/common';
import { data, event } from 'jquery';
import { MatTableDataSource } from '@angular/material/table';
import { IAViewEvent } from '../../../../../shared/models/iaview-event';
import { MatSort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-viewevent',
  templateUrl: './viewevent.component.html',
  styleUrl: './viewevent.component.css',
  providers: [DatePipe]
})
export class VieweventComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource1!: MatTableDataSource<IAViewEvent>
  //
  displayedColumns: string[] = ['serialNumber', 'eventId', 'interventionName', 'componentName', 'eventName', 'eventDate', 'time', 'eventStatus', 'action', 'liveEventURL', 'report', 'upload', 'spotRegistration', 'viewEnrolledMSME', 'viewAttendedMSME',
    'viewFeedback'
  ]
  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  viewEventForm: FormGroup;
  totalEvent: number = 0;
  pendingEvent: number = 0;
  approvedEvent: number = 0;
  rejectedEvent: number = 0;
  // Your full data source
  dataSource: any[] = [];
  allrecord: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes

  page = 1;
  pageSize = 20;
  length: number = 0;
  displayedData: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  pageSizeOptions1: number[] = [10, 20, 50, 100];
  page1 = 1;
  pageSize1 = 20;
  length1: number = 0;
  displayedData1: any[] = [];
  hidePageSize1 = false;
  showPageSizeOptions1 = true;
  showFirstLastButtons1 = true;
  disabled1 = false;
  pageIndex1 = 0;
  pageEvent1!: PageEvent;
  UploadButtonText: any;
  popupSubmit = true;
  controlDisableEnabled:boolean = true;

  dtoPagination =
    {
      /*"UserId": sessionStorage.getItem("iauserid"),*/
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": "",
      "TodayTommarow": "",
      "FromDate": "",
      "ToDate": ""
    }

  dtoPagination1 =
    {
      "UserId": sessionStorage.getItem("iauserid"),
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "eventDate",
      "SortDirection": "desc",
      "SearchTerm": "",
      "SearchCol": "",
      "TodayTommarow": "",
      "FromDate": "",
      "ToDate": ""
    }

  showList: boolean = true;
  showCalender: boolean = false;
  showBlock: boolean = false;
  currentView: string = 'list';
  today: string = '';

  actionButton: string='';
  constructor(private apiService: ApiService, private router: Router, private toastr: ToastrService, private storageService: StorageService, public commonService: CommonService, private datePipe: DatePipe, public dialog: MatDialog, private fb: FormBuilder) {
    this.viewEventForm = new FormGroup({
      today: new FormControl(false),
      tomorrow: new FormControl(false),
      fromDate: new FormControl(null),
      toDate: new FormControl(null),
      searchControl: new FormControl(''),
      liveEventURL: new FormControl(),
      hiddenValue: new FormControl(),
    });
  }

  ngOnInit(): void {
    this.dtoPagination.PageSize = 20;
    this.dtoPagination.SearchCol = this.commonService.searchText;
    sessionStorage.getItem('iauserid');
    sessionStorage.getItem('uniqueeventid');
    sessionStorage.getItem('eventid');
  }

  ngAfterViewInit() {
    this.loadData();
  }

  onListView() {
    this.currentView = 'list';
    window.location.reload();
    /*this.loadData();*/
  }

  onCalenderView() {
    this.currentView = 'calender';
  }

  onCardView() {
    this.currentView = 'block';
    this.LoadDetails();
  }

  LoadDetails() {
    //dtoPagination.SearchTerm = this.viewEventForm.get('search')?.value;
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIAEventList, this.dtoPagination1).subscribe(
      result => {
        if (result.status) {
          
          var summary = result.data.item1;
          this.dataSource = result.data.item2;
          //this.dataSource1 = result.data.item2;
          this.length1 = summary["totalCount"];
          
          this.today = this.formatDate(new Date());

          this.totalEvent = summary["totalCount"];
          this.pendingEvent = summary["pendingCount"];
          this.approvedEvent = summary["approvedCount"];
          this.rejectedEvent = summary["rejectedCount"];
        } else {
          this.toastr.error(result.message);
        }
      }
    )


  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.dtoPagination.SortColumn = this.sort.active;
          this.dtoPagination.SortDirection = this.sort.direction;
          this.dtoPagination.SearchCol = this.commonService.searchText;
          this.dtoPagination.ToDate = this.dtoPagination.ToDate ?? "";
          this.dtoPagination.FromDate = this.dtoPagination.FromDate ?? "";
          this.dtoPagination.TodayTommarow = this.dtoPagination.TodayTommarow ?? "";

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIAEventList, this.dtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp.data.item1.totalCount;
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        var summary = data.item1;
        this.totalEvent = summary["totalCount"];
        this.pendingEvent = summary["pendingCount"];
        this.approvedEvent = summary["approvedCount"];
        this.rejectedEvent = summary["rejectedCount"];
        this.dataSource1 = data.item2;
        this.UploadButtonText = "View Document";
        this.adjustPaginator();
      });
  }

  // Cleanup subscriptions when component is destroyed
  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  //loadData() {
    
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.dtoPagination.SortColumn = this.sort.active;
  //        this.dtoPagination.SortDirection = this.sort.direction;
  //        //this.DtoPagination.SearchTerm = (searchTerm && typeof searchTerm == 'string') ? searchTerm.toString() : '';
  //        this.dtoPagination.SearchCol = this.commonService.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIAEventList, this.dtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp.status) {
           
  //          this.length = resp.data.item1.totalCount; //resp['totalRecords'];
  //        }
  //        return resp.data;
  //      })
  //    ).subscribe(data => {
  //      var summary = data.item1;
  //      this.totalEvent = summary["totalCount"];
  //      this.pendingEvent = summary["pendingCount"];
  //      this.approvedEvent = summary["approvedCount"];
  //      this.rejectedEvent = summary["rejectedCount"];
  //      this.dataSource1 = data.item2;
  //      this.adjustPaginator();
  //    });
  //}

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.dtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  //checkDocumentDate(uploadDate: string): string {
  //  const [day, month, year] = uploadDate.split('/').map(Number); // Convert dd/MM/yyyy to numbers
  //  const docDate = new Date(year, month - 1, day); // Month is 0-based in JS

  //  docDate.setDate(docDate.getDate() + 3); // Add 3 days to document date

  //  const today = new Date();

  //  if (docDate < today) {
  //    return "Document Date is Expired";
  //  } else if (docDate > today) {
  //    return "Document Date is not yet come";
  //  } else {
  //    return "Document Date is Today";
  //  }
  //}

  
  checkDate(dateString: string): boolean {
    if (!dateString) return false;
    
    const [day, month, year] = dateString.split('/').map(Number); // Convert dd/MM/yyyy to numbers
    const docDate = new Date(year, month - 1, day); // Month is 0-based in JS
    //docDate.setDate(docDate, -3)
    //docDate.setDate(docDate.getDate() - 3);//final
    docDate.setDate(docDate.getDate() - 1);//temp

    const today = new Date(); // Get today's date
    //today.setDate(today.getDate() - 3); // Subtract 3 days

    today.setHours(0, 0, 0, 0); // Normalize to midnight
    docDate.setHours(0, 0, 0, 0); // Normalize to midnight

    // Check if the document date is within the last 3 days
    //const threeDaysAgo = new Date();
    //threeDaysAgo.setDate(today.getDate() - 3);

    return docDate >= today; // Returns true for "Edit", false for "View"
  }

    // Method to check if the current date is 2 days before the event date
  //checkEventDateAndDisableControls() {
    
  //  const currentDate = new Date();
  //  const date = this.eventDate;
  //  const twoDaysBeforeEvent = new Date(date);
  //  twoDaysBeforeEvent.setDate(twoDaysBeforeEvent.getDate() - 2);

  //  // If current date is 2 days or less before the event date, disable the controls
  //  if (currentDate >= twoDaysBeforeEvent) {
  //    this.disableAllControls();
  //  } else {
  //    this.enableAllControls();
  //  }
  //}

  isBeforeToday(dateString: string): boolean {
    
    const eventDate = this.convertToDateObjectNew(dateString)
    //const today = this.getTodayMidnight();

    const toda = new Date();
    const today = this.formatDate(toda);

    //if (dateString.replaceAll('/', '-') < today)
    //  this.actionButton = 'View';
    //else
    //  this.actionButton = 'Edit';

    return eventDate < toda; //dateString.replaceAll('/', '-') < today;
  }

  convertToDateObjectNew(inputDate: string): Date {
    const [day, month, year] = inputDate.split(" ")[0].split("/");
    return new Date(Number(year), Number(month) - 1, Number(day), 0, 0, 0);
  }

  isDateToday(dateString: string): boolean {
    
    //var eveDt = new Date(this.convertToDateString(dateString))
    //const eventDate = this.parseDate(eveDt) ;//this.parseDate(dateString);
    const toda = new Date();
    const today = this.formatDate(toda) //this.getTodayMidnight();

    return dateString.replaceAll('/', '-') == today; //eventDate.getTime() === today.getTime();
  }

convertToDateString(inputDate: string): string {
  // Split the input date and extract day, month, year
  const [day, month, year] = inputDate.split(" ")[0].split("/");

  // Create a Date object (months in JS are 0-based, so subtract 1 from month)
  const date = new Date(Number(year), Number(month) - 1, Number(day), 0, 0, 0);

  // Convert to the desired format
  return date.toString(); // Output: "Tue Feb 11 2025 00:00:00 GMT+0530"
}

  // ✅ Helper function to parse dd-MM-yyyy string
  private parseDate(dateString: string): Date {
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  // ✅ Helper function to get today's date at midnight
  private getTodayMidnight(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  // Format date
  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Submit data
  onSubmit() {
    //this.LoadDetails();
    this.loadData();
  }

  // Edit data
  onEdit(eventid: string, proposaluserid: string): void {
    //this.storageService.setTwoParams(eventid, proposaluserid);
    //this.router.navigate(['/editevent']);
    this.router.navigate(['/editevent', eventid, proposaluserid]);

  }

  isBeforeTodayDate(dateString: string): boolean {
    
    var dt = dateString.split('/');
    var dt1 = dt[2] + '-' + dt[1] + '-' + dt[0];

    
    const dateObject: Date = new Date(dt1);

    //const [d, m, y] = dateString.split('/').map(Number);
    //const candidate = new Date(y, m - 1, d-1);   // months are 0‑based

    // Subtract one day from dateObject
    const oneDayBefore = new Date(dateObject);
    oneDayBefore.setDate(dateObject.getDate() - 1); // Reduce by 1 day

    const todaay = new Date();
    //const today = this.formatDate(toda);

    //const eventDate = this.formatDate(candidate);

    return oneDayBefore <= todaay;

   
  }



  ///** True when the event is more than two days in the future. */
  //isMoreThanTwoDaysAhead(date: string | Date): boolean {
  //  const d = new Date(date);
  //  const today = new Date();
  //  today.setHours(0, 0, 0, 0);

  //  const gate = new Date(today);
  //  gate.setDate(today.getDate() + 2);     // two days from now

  //  return d >= gate;
  //}


  onLiveEventURLEdit(templateRef: TemplateRef<any>, eventid: string,eventStatus:string): void {
    var data = {
      UniqueEventId: eventid,
      /*proposaluserid: proposaluserid*/
    };
    this.apiService.getRequest(API_ENDPOINTS.IA.GETEVENTURL, data).subscribe(
      (result: any) => {
        
        if (eventStatus == 'Completed') {//,eventStatus:string
          this.popupSubmit = false;
          this.viewEventForm.get('liveEventURL')?.disable();
          
        }else{
          this.popupSubmit = true;
          this.viewEventForm.get('liveEventURL')?.enable(); 
        }
        //this.viewEventForm.get();
        localStorage.setItem("uniqueEventId", result['liveEventURL'][0]['uniqueEventId'])
        //this.viewEventForm.get('hiddenValue')?.setValue(result['liveEventURL'][0]['uniqueEventId']);
        this.viewEventForm.get('liveEventURL')?.setValue(result['liveEventURL'][0]['liveEventURL']);
        //this.toastr.success('Implementation Details added successfully!', 'Good job!');
        //this.router.navigate(['/view_event']);
        this.dialog.open(templateRef, {
          width: '400px', // Customize the width of the dialog
          height: '210px', // Optionally customize the height
        });
      },
      error => {
        this.toastr.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
      }
    );
    
  }

  updateURL() {
    if (this.viewEventForm.get('liveEventURL')?.value) {
      var data = {
        UniqueEventId: localStorage.getItem("uniqueEventId"),
        LiveEventURL: this.viewEventForm.get('liveEventURL')?.value
      }
      this.apiService.postRequest(API_ENDPOINTS.IA.UPDATELIVEEVENTURL, data).subscribe(
        (result: any) => {
          this.toastr.success('Event URL Updated successfully!', 'Success!');
          setTimeout(() => {
            this.dialog.closeAll();
          }, 1000);
          
        },
        error => {
          this.toastr.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
        }
      );
    }
  }



  // Redirect to output report
  onOutputReport(eventid: string) {
    this.router.navigate(['/event_report', eventid]);
  }

  // Redirect to document upload page
  onUpdate(eventid: string): void
  {    
      this.router.navigate(['/eventcompletion', eventid]);   
  }
  
  onMarkAttendance(eventid: string): void {
    this.router.navigate(['/eventmarkattendance', eventid]);
  }


  // Redirect to  view event documents
  onViewEventDocs(eventid: string): void {    
      this.router.navigate(['/vieweventdocuments', eventid]);    
  }
  
  onViewEnrolledMSME(eventid: string): void {
    this.router.navigate(['/viewEnrolledParticipants', eventid]);
  }

  onViewAttendedMSME(eventid: string): void {
    this.router.navigate(['/viewAttendedParticipants', eventid]);
  }

  onViewFeedback(eventid: string): void {
    this.router.navigate(['/viewFeedbacksListia', eventid]);
  }

  //Redirect to on spot registration page
  onSpot(row:any,eventid: string): void {
    sessionStorage.setItem("uniqueEventId", eventid);
    sessionStorage.setItem("EventId", eventid);
    sessionStorage.setItem("Intervention", row.interventionName);
    sessionStorage.setItem("Component", row.componentName);
    this.router.navigate(['/viewallonspotregistration', eventid]);
  }
    
  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.dtoPagination.PageNumber = e.pageIndex + 1;
    this.dtoPagination.PageSize = e.pageSize;
    //this.LoadDetails();
    this.loadData();
  }

  onCardPageChange(e: PageEvent) {
    this.pageEvent1 = e;
    this.length1 = e.length;
    this.pageSize1 = e.pageSize;
    this.pageIndex1 = e.pageIndex;

    this.dtoPagination1.PageNumber = e.pageIndex + 1;
    this.dtoPagination1.PageSize = e.pageSize;
    this.LoadDetails();
    //this.loadData();
  }

  //onSearchClick(searchValue: string): void {

  //  const searchControl = this.viewEventForm.get('search');
  //  searchControl?.markAsTouched();

  //  if (searchControl?.valid && searchValue.trim() !== '') {
  //    this.dtoPagination.SearchTerm = searchValue.trim();
  //    this.dtoPagination.SearchCol = this.commonService.searchText;
  //    //this.LoadDetails();
  //    this.loadData();
  //  }
  //}

  //onSearchClick(searchValue: string): void {
  //  const searchControl = this.viewEventForm.get('searchControl');
  //  const fromDateControl = this.viewEventForm.get('fromDate');
  //  const toDateControl = this.viewEventForm.get('toDate');

  //  if ((searchControl?.value && searchValue.trim() !== '')
  //    || (fromDateControl?.value && toDateControl?.value)) {
  //    this.dtoPagination.SearchTerm = searchValue.trim();
  //    this.dtoPagination.SearchCol = this.commonService.searchText;

  //    this.dtoPagination.FromDate = fromDateControl?.value
  //      ? this.datePipe.transform(fromDateControl.value, 'yyyy-MM-dd')!
  //      : '';
  //    this.dtoPagination.ToDate = toDateControl?.value
  //      ? this.datePipe.transform(toDateControl.value, 'yyyy-MM-dd')!
  //      : '';

  //    //this.loadReport(this.DtoPagination);
  //    this.loadData();
  //  } else if (searchValue.trim() === '') {
  //    searchControl?.markAsTouched();
  //  } else {
  //    searchControl?.markAsTouched();
  //  }
  //}

  onSearchClick(searchValue: string): void {
    const searchControl = this.viewEventForm.get('searchControl');
    const fromDateControl = this.viewEventForm.get('fromDate');
    const toDateControl = this.viewEventForm.get('toDate');

    // 👉 Clear Today/Tomorrow flags
    this.viewEventForm.patchValue({
      today: false,
      tomorrow: false
    });
    this.dtoPagination.TodayTommarow = "";

    // 👉 Validate From/To date
    if (fromDateControl?.value && toDateControl?.value) {
      if (fromDateControl.value > toDateControl.value) {
        this.toastr.error('From Date should be less than To Date.');
        this.viewEventForm.patchValue({
          fromDate: null,
          toDate: null
        });
        this.viewEventForm.setErrors({ dateRangeInvalid: true });
        return; // stop here, do not search
      } else {
        // clear error if previously set
        if (this.viewEventForm.hasError('dateRangeInvalid')) {
          this.viewEventForm.setErrors(null);
        }
      }
    }

    // 👉 Proceed with search
    if ((searchControl?.value && searchValue.trim() !== '')
      || (fromDateControl?.value && toDateControl?.value)) {

      this.dtoPagination.SearchTerm = searchValue.trim();
      this.dtoPagination.SearchCol = this.commonService.searchText;

      this.dtoPagination.FromDate = fromDateControl?.value
        ? this.datePipe.transform(fromDateControl.value, 'yyyy-MM-dd')!
        : '';
      this.dtoPagination.ToDate = toDateControl?.value
        ? this.datePipe.transform(toDateControl.value, 'yyyy-MM-dd')!
        : '';

      this.loadData();
    } else {
      searchControl?.markAsTouched();
    }
  }


  resetPage() {
    this.dtoPagination = {
      //UserId: sessionStorage.getItem("iauserid"),
      PageNumber: 1,
      PageSize: 20,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: "",
      TodayTommarow: "",
      FromDate: "",
      ToDate: ""
    };

    this.loadData();
  }

  //resetPage() {
  //  this.dtoPagination.SearchTerm = "";
  //  this.dtoPagination.SearchCol = this.commonService.searchText;
  //  //this.LoadDetails();
  //  this.loadData()
  //}


  exportToExcel(): void {
    const DtonullPagination = {
      UserId: sessionStorage.getItem("iauserid"),
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "eventDate",
      SortDirection: "desc",
      SearchTerm: "",
      TodayTommarow: "",
      FromDate: "",
      ToDate: ""
    };

    const fileName = 'Event_List.xlsx';

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETIAEventList, DtonullPagination).subscribe(
      (result) => {
        if (!result || !result.status || !result.data) {
          this.toastr.error('No data available to export.');
          return;
        }

        this.allrecord = result.data.item2;

        if (this.allrecord.length === 0) {
          this.toastr.error('No data available to export.');
          return;
        }

        // Mapping API response to match table fields
        const excelData = this.allrecord.map((item, index) => ({
          'Sr.No': index + 1,
          'Event Id':item.eventId,
          'Intervention Name': item.interventionName,
          'Component Name': item.componentName,
          'Event Name': item.eventName,
          'Event Date': item.formattedEventDate,
          'Time': item.time,
          'Action': item.uniqueEventId ? (this.checkDate(item.formattedEventDate) ? 'Edit' : 'View') : 'N/A',
          'Report': this.isBeforeToday(item.formattedEventDate) ? 'Available' : 'Not Available',
          'Upload': this.getUploadStatus(item.update),
          'Spot Registration': this.isDateToday(item.formattedEventDate) ? 'Available' : 'Not Available'
        }));

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
        worksheet['!cols'] = [
          { wch: 10 }, { wch: 15 },{ wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 15 },
          { wch: 10 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }
        ];

        const workbook: XLSX.WorkBook = {
          Sheets: { 'Event List': worksheet },
          SheetNames: ['Event List'],
        };

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data: Blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });

        saveAs(data, fileName);
        this.toastr.success('Excel exported successfully!');
      },
      (error) => {
        this.toastr.error('Failed to export data.');
        console.error('Export Error:', error);
      }
    );
  }

  private getUploadStatus(update: string): string {
    switch (update) {
      case 'UpdateButton': return 'Upload Document';
      case 'ViewDocumentsButton': return 'View Document';
      case 'Nothing': return 'Unavailable';
      case 'Done': return 'Completed';
      default: return 'N/A';
    }
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  isEventDatePassed(eventDateString: string): boolean {
    if (!eventDateString) {
      return false; // Or handle as per your logic if eventDate is missing
    }
    // Assuming eventDateString is in a format like "MM/DD/YYYY HH:mm:ss"
    // like "06/16/2025 17:46:02" from your API example.
    // Use a Date object for reliable comparison.
    const eventDate = new Date(eventDateString);
    const currentDate = new Date();

    // Set time to 00:00:00 for both dates if you only care about the day
    // eventDate.setHours(0, 0, 0, 0);
    // currentDate.setHours(0, 0, 0, 0);

    return eventDate <= currentDate; // Returns true if eventDate is in the past or today
  }

  // Define an array of event IDs that can bypass the 'ViewDocumentsButton' disable condition
  allowedViewDocumentsButtonEventIds: string[] = [
    //'SPTECH_CB_87',
    //'SPTECH_CB_59',
    //'SPTECH_CB_92',
    //'SPTECH_CB_93',
    //'SPTECH_CB_94',
    //'SPTECH_CB_95',
    //'SPTECH_CB_78',
    //'WXCPL_CB_21',
    //'WXCPL_CB_22',
    //'WXCPL_CB_8',
    //'SPTECH_CB_74',
    //'SPTECH_CB_14',
    //'SIPL_CB_265',
    //'EDII_CB_326',
    
    'Justrojgar_CB_422',
    'Justrojgar_CB_422',
    'Justrojgar_CB_429',
    'Justrojgar_CB_429',
    'Justrojgar_CB_441',
    'Justrojgar_CB_441',
    'Justrojgar_CB_469',
    'Justrojgar_CB_469',
    'Justrojgar_CB_473',
    'Justrojgar_CB_473',
    'Justrojgar_CB_470',
    'Justrojgar_CB_470'

    // ... add as many as needed
  ];

  isSpotRegOpen(dateStr: string, timeStr: string): boolean {
    // dateStr: "dd/MM/yyyy", timeStr: "h:mm AM/PM"
    if (!dateStr || !timeStr) return false;

    const [d, m, y] = dateStr.split('/').map(Number);
    const now = new Date();

    // ✅ Only today
    if (
      now.getFullYear() !== y ||
      now.getMonth() !== (m - 1) ||
      now.getDate() !== d
    ) {
      return false; // not today → never show
    }

    // Parse time
    const match = timeStr.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) return false;

    let hh = parseInt(match[1], 10);
    const mm = parseInt(match[2], 10);
    const ampm = match[3].toUpperCase();

    if (ampm === 'PM' && hh < 12) hh += 12;
    if (ampm === 'AM' && hh === 12) hh = 0;

    const eventDateTime = new Date(y, m - 1, d, hh, mm, 0, 0);

    // ✅ Open only after event time has begun (prevents previous dates)
    return now.getTime() >= eventDateTime.getTime();
  }
  onButtonClick(selected: 'today' | 'tomorrow') {
    this.viewEventForm.patchValue({
      today: selected === 'today',
      tomorrow: selected === 'tomorrow',
      fromDate: null,
      toDate: null,
      searchControl: null
    });

    const todayControl = this.viewEventForm.get('today');
    const tomorrowControl = this.viewEventForm.get('tomorrow');
    let selectedDate: Date | null = null;

    if (todayControl?.value) {
      selectedDate = new Date(); // Today
    } else if (tomorrowControl?.value) {
      selectedDate = new Date();
      selectedDate.setDate(selectedDate.getDate() + 1); // Tomorrow
    }
    this.dtoPagination.TodayTommarow = selectedDate
      ? selectedDate.toISOString().slice(0, 10)! // Format: YYYY-MM-DD
      : '';

    this.loadData();
  }

  dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    const from = group.get('fromDate')?.value;
    const to = group.get('toDate')?.value;

    if (from && to && from > to) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  onDateChange(): void {
    // when user selects a date, reset today/tomorrow buttons
    this.viewEventForm.patchValue({
      today: false,
      tomorrow: false
    });

    // Optional: check validity immediately
    const from = this.viewEventForm.get('fromDate')?.value;
    const to = this.viewEventForm.get('toDate')?.value;

    if (from && to && from > to) {
      this.viewEventForm.setErrors({ dateRangeInvalid: true });
    } else {
      // clear error if valid
      if (this.viewEventForm.hasError('dateRangeInvalid')) {
        this.viewEventForm.setErrors(null);
      }
    }
  }
  
}
